export type ProjectItem = {
  id: number;
  image: string;
  tags: Array<{ label: string; tone: 'blue' | 'orange' | 'teal' | 'yellow' | 'green' | 'gray' }>;
  title: string;
  description: string;
};

export const projectsData: ProjectItem[] = [
  {
    id: 1,
    image: '/assets/images/projects/mining-survelliance.png',
    tags: [
      { label: 'Security', tone: 'blue' },
      { label: 'Mining', tone: 'gray' }
    ],
    title: 'Mining Site Surveillance System',
    description:
      'Deployed 200+ IP cameras with centralized monitoring across a major mining operation in Katanga province, including perimeter security and vehicle tracking.'
  },
  {
    id: 2,
    image: '/assets/images/projects/fire-alarm-systems.png',
    tags: [
      { label: 'Fire Safety', tone: 'orange' },
      { label: 'Corporate', tone: 'gray' }
    ],
    title: 'Commercial Fire Detection & Alarm',
    description:
      'Multi-zone fire detection and alarm system for a commercial office building in Lubumbashi, covering all floors with automated suppression.'
  },
  {
    id: 3,
    image: '/assets/images/projects/hotel-vrf.png',
    tags: [
      { label: 'HVAC', tone: 'teal' },
      { label: 'Hospitality', tone: 'gray' }
    ],
    title: 'Hotel VRF Climate Control',
    description:
      'Complete VRF system installation for a 120-room hotel, including individual room climate control and energy management.'
  },
  {
    id: 4,
    image: '/assets/images/projects/solar-streetlight.png',
    tags: [
      { label: 'Solar', tone: 'yellow' },
      { label: 'Municipal', tone: 'gray' }
    ],
    title: 'Solar Streetlight Installation',
    description:
      'Solar-powered streetlight deployment across a major industrial park, reducing energy costs by 60% and improving nighttime safety.'
  },
  {
    id: 5,
    image: '/assets/images/projects/city-surveillance.png',
    tags: [
      { label: 'Security', tone: 'blue' },
      { label: 'Government', tone: 'gray' }
    ],
    title: 'City Surveillance Network',
    description:
      'Urban surveillance network with 300+ cameras for city monitoring, integrated with command center and real-time analytics.'
  },
  {
    id: 6,
    image: '/assets/images/projects/Warehouse-maintenance.png',
    tags: [
      { label: 'Maintenance', tone: 'green' },
      { label: 'Industrial', tone: 'gray' }
    ],
    title: 'Warehouse Maintenance Program',
    description:
      'Ongoing preventive maintenance program covering CCTV, fire systems, and HVAC for 50+ warehouses across the DRC.'
  }
];
